import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, ButtonGroup } from 'ui';
import AlertBox from 'components/shared/AlertBox';
import LinkButton from 'components/shared/LinkButton';
import CSRFForm from 'components/shared/CSRFForm';
import RadioFieldGroup from 'components/shared/RadioFieldGroup/index';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';
import { routes } from 'constants/config';

const ArchiveConfirmation = ({ event, onDismiss, session }) => {
  const [emailConfirmation, setEmailConfirmation] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleEmailConfirmationChange = useCallback(
    e => setEmailConfirmation(JSON.parse(e.target.value)),
    [],
  );

  const showSendEmailOption = session
    ? moment(session.start_time_utc).isAfter()
    : !!event.next_session;

  return (
    <AlertBox onDismiss={loading ? null : onDismiss}>
      <CSRFForm
        url={
          session
            ? routes.IN_PERSON_TRAINING.ARCHIVE_SESSION(event.id, session.id)
            : routes.IN_PERSON_TRAINING.ARCHIVE_EVENT(event.id)
        }
        onSubmit={() => setLoading(true)}
      >
        <h2 className="ff-ss mb-16">
          {session
            ? t('in_person_training.session.confirmations.archive.title')
            : t(
                'in_person_training.event_overview.confirmations.archive.title',
              )}
        </h2>
        {showSendEmailOption && (
          <RadioFieldGroup
            selectedValue={emailConfirmation}
            className="mb-16"
            name="send_cancellation_email"
            onChange={handleEmailConfirmationChange}
          >
            <RadioField className="p-4-8" value={true}>
              {t(
                'in_person_training.event_overview.confirmations.archive.send_email',
              )}
            </RadioField>
            <RadioField className="p-4-8" value={false}>
              {t(
                'in_person_training.event_overview.confirmations.archive.do_not_send_email',
              )}
            </RadioField>
          </RadioFieldGroup>
        )}
        <ButtonGroup alignEnd>
          <LinkButton
            disabled={loading}
            type="primary"
            className="mr-8"
            onClick={onDismiss}
          >
            {t('common.cancel')}
          </LinkButton>
          <Button loading={loading} submit customColor>
            {t('common.archive')}
          </Button>
        </ButtonGroup>
      </CSRFForm>
    </AlertBox>
  );
};

const mapStateToProps = state => ({
  event: state.event,
});

export default connect(mapStateToProps)(ArchiveConfirmation);
